import React from "react";
import { inject, observer } from "mobx-react";
import "./legalGroup.scss";
import DropDown from "../dropDown/dropDown";
import { ClientLegalForm, ClientLegalGroup, ClientLegalGroupDropDown, ClientModel } from "../../../helpers/client";
import { CalculateStore } from "../../../stores/calculateStore";
import { CalculationService } from "../../../services/services/calculationService";
import { runInAction } from "mobx";

interface LegalGroupProps {
    calculateStore?: CalculateStore;
    client: ClientModel;
    disabled?: boolean;
    label?: string;
    calculationService?: CalculationService;
}

export function LegalGroup(props: LegalGroupProps) {
    const calculateStore = props.calculateStore!;
    const client = props.client;
    const recalculateOnChange = client.insurer;
    const value = client.legalGroup;
    const label = props.label ?? "Rodzaj ubezpieczającego";
    const calculationService = props.calculationService!;

    return (
        <div className="legal-group">
            <div className="question-answer-container">
                <div className="question">{label}</div>
                <DropDown onChange={(val) => {
                    resetLegalForm();
                    runInAction(() => {
                        // TODO: create setter and remove 'runInAction'
                        client.legalGroup = val;
                    });
                    if (recalculateOnChange) {
                        calculateStore.setRequireRecalculate(true);
                    }
                    calculationService.setRisksNetworkForAllPackages();
                }}
                    disabled={props.disabled}
                    value={value as string}
                    items={ClientLegalGroupDropDown}
                />
            </div>
        </div>
    );

    function resetLegalForm() {
        client.legalForm.setValue(client.legalGroup === ClientLegalGroup.PERSON ? ClientLegalForm.PRIVATE : undefined);
    }
}

export default inject("clientStore", "calculateStore", "calculationService")(observer(LegalGroup));
